import { GetVehicleResponseV2VM } from '@optimization/sa-common';
import { useMemo } from 'react';
import { VehicleRoutes } from './routingTypes';

export const parseVehicleRoutes = (vehicle: GetVehicleResponseV2VM): VehicleRoutes | undefined => {
  if (vehicle.Routes) {
    try {
      const result = JSON.parse(vehicle.Routes) as VehicleRoutes;

      const updatedAt = new Date(result.UpdatedAt);
      const cutoffDate = new Date('2025-05-21T14:00:00Z');

      if (updatedAt >= cutoffDate && result.Waypoints.length) {
        return result;
      }
    } catch (error) {
      console.error('Failed to parse vehicle.Routes:', error);
    }
  }

  return undefined;
};

interface Props {
  vehicle: GetVehicleResponseV2VM;
}

const useVehicleRoutes = ({ vehicle }: Props): VehicleRoutes | undefined =>
  useMemo(() => parseVehicleRoutes(vehicle), [vehicle]);

export default useVehicleRoutes;
